import _ from 'lodash';

const getId = (item?: { id?: string | null } | string | null) =>
  item && (typeof item === 'string' ? item : item.id);

function updateApolloListItem<
  Prev extends object,
  Item extends { id?: string | null } | string,
  NewItem extends Item,
>(prev: Prev, targetPath: string, newItem: NewItem, add = true) {
  const list: [Item] = _.get(prev, targetPath);
  if (!list) {
    return prev;
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention -- Add boolean prefix next time file is edited
  let match = false;
  const newItemId = getId(newItem);
  const updated = list.map((item) => {
    const itemId = getId(item);
    if (itemId === newItemId) {
      if (add) {
        match = true;
        return newItem;
      }
      return null;
    }
    return item;
  });

  if (add && !match) {
    updated.push(newItem);
  }

  return _.setWith(_.clone(prev), targetPath, _.compact(updated), _.clone);
}

export default function updateApolloList<
  Prev extends object,
  Data extends { [key in ItemKey]?: NewItem | null },
  ItemKey extends string,
  NewItem extends Item,
  Item extends { id?: string | null } | string,
>(prev: Prev, data: Data, listPath: string, itemKey: ItemKey, add = true) {
  const newItem = data?.[itemKey];
  if (!prev || !newItem) {
    return prev;
  }

  return updateApolloListItem(prev, listPath, newItem, add);
}
